import { render, staticRenderFns } from "./TicketHeader.vue?vue&type=template&id=177755a9&scoped=true"
import script from "./TicketHeader.vue?vue&type=script&lang=js"
export * from "./TicketHeader.vue?vue&type=script&lang=js"
import style0 from "./TicketHeader.vue?vue&type=style&index=0&id=177755a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177755a9",
  null
  
)

export default component.exports